import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext({
  isAuthenticated: false,
  login: () => {},
  logout: () => {},
  loading: false
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check for existing session on mount
  useEffect(() => {
    const checkAuth = () => {
      // Check localStorage for authentication
      const authStatus = localStorage.getItem('admin_authenticated');
      const authTimestamp = localStorage.getItem('admin_auth_timestamp');
      
      if (authStatus === 'true' && authTimestamp) {
        // Check if session is still valid (24 hours)
        const timestamp = parseInt(authTimestamp, 10);
        const now = Date.now();
        const hoursDiff = (now - timestamp) / (1000 * 60 * 60);
        
        if (hoursDiff < 24) {
          setIsAuthenticated(true);
        } else {
          // Session expired
          localStorage.removeItem('admin_authenticated');
          localStorage.removeItem('admin_auth_timestamp');
        }
      }
      
      setLoading(false);
    };
    
    checkAuth();
  }, []);

  const login = (password) => {
    // For demo purposes, use a simple password
    // In production, this would validate against a backend or environment variable
    const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD || 'admin123';
    
    if (password === adminPassword) {
      setIsAuthenticated(true);
      localStorage.setItem('admin_authenticated', 'true');
      localStorage.setItem('admin_auth_timestamp', Date.now().toString());
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('admin_authenticated');
    localStorage.removeItem('admin_auth_timestamp');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;